/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedAssessmentRunCreateMilestoneRequest {
    getFixupPrototypeFunction() { return WellArchitectedAssessmentRunCreateMilestoneRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedAssessmentRunCreateMilestoneRequest>): WellArchitectedAssessmentRunCreateMilestoneRequest {
        let obj = Object.assign(new WellArchitectedAssessmentRunCreateMilestoneRequest(), model);
        WellArchitectedAssessmentRunCreateMilestoneRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedAssessmentRunCreateMilestoneRequest>): WellArchitectedAssessmentRunCreateMilestoneRequest {
        if (!model) return null;
        return WellArchitectedAssessmentRunCreateMilestoneRequest.newInstance(<WellArchitectedAssessmentRunCreateMilestoneRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedAssessmentRunCreateMilestoneRequest) {
        if (!obj) return;

        models.WellArchitectedAssessmentRunCreateMilestoneRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedAssessmentRunCreateMilestoneRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedAssessmentRunCreateMilestoneRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the milestone to create.
     */
    name: string;

}
